  const partnerRoutes = {
    partner: "/partner",
    PartnerDetail: "/partner/details",
  };

  export default partnerRoutes;
